export const noop = () => 0;
export const isDefined = obj => obj !== null && obj !== undefined;

export const TYPE_OBJECT = '[object Object]';
export const TYPE_ARRAY = '[object Array]';
export const TYPE_NUMBER = '[object Number]';
export const TYPE_BOOL = '[object Boolean]';
export const TYPE_STRING = '[object String]';
export const TYPE_UNDEFINED = '[object Undefined]';
export const TYPE_NULL = '[object Null]';
export const TYPE_FUNCTION = '[object Function]';
export const isTypeOf = (obj, type) => Object.prototype.toString.call(obj) === type;

export const debounce = (fn, delay, options) => {
    fn = fn || noop;
    options = { leading: true, ...options };

    let leadingUsed = false;
    let timer = null;
    const debounced = (...args) => {
        if (timer) {
            clearTimeout(timer);
        }
        if (options.leading && !leadingUsed) {
            fn(...args);
            leadingUsed = true;
        } else {
            timer = setTimeout(() => {
                fn(...args);
                timer = null;
            }, delay);
        }
    };

    debounced.cancel = () => {
        if (timer) {
            clearTimeout(timer);
        }
    };

    return debounced;
};

export const asFunction = obj => typeof obj === 'function' ? obj : () => obj;
